export const APP_FILE_REPORTS = "/report/create";
export const APP_FILE_REPORTS_VIEW = "/report/view";
export const APP_FILE_REPORT_LIST = "/reports";